<template>
  <span
    class="em-body-2"
    :class="{'bold': bold, 'semi-bold': semiBold, 'regular': !bold && !semiBold}"
    v-bind="$attrs"
  >
    <slot />
  </span>
</template>
<script setup>
defineProps({
  bold: {
    type: Boolean,
    default: false
  },
  semiBold: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" scoped>
  .em-body-2{
    font-size: 15px;
    letter-spacing: 0px;
    line-height: 26px;
  }
  .em-body-2 :deep(.v-label) {
    font-size: 15px;
    letter-spacing: 0px;
    line-height: 26px;
  }
</style>
